module.exports = __webpack_public_path__ + "img/static-brand2@2x.1d6364df.png";